import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import { FornecedorResult } from '@app/api/fornecedor';
import { Col, ColumnProps, Form, FormInput, FormResetButton, Row, Table, notification, Button } from '@digital/ui';
import { compareText, compareTypeNumber } from '@app/helpers/comparators';
import { Icon, Tooltip } from 'antd';
import { CtrPcsResultData } from '@app/api/ctrPcs';
import { alterarForncedorDoPcm, alterarForncedorDoPcmCrf, PosFornecedorPcm } from '@app/api/manutencaoPcmFornecedorController';


export interface ModalFornecedorProps {
    fornecedoresResult: FornecedorResult[];
    pcmResult: CtrPcsResultData;
    atualizarTabelaResult: () => void;
    crf: boolean
}

const ModalFornecedor = (props: ModalFornecedorProps) => {

    const { fornecedoresResult, pcmResult, atualizarTabelaResult, crf } = props;
    const [visible, setVisible] = useState<boolean>(false);
    const [fornecedorSelecionada, setFornecedorSelecionada] = useState<FornecedorResult>();


    const rowSelection = {
        onChange: (selectedRowKeys: string, selectedRows: FornecedorResult[]) => {
            setFornecedorSelecionada(selectedRows[0]);
        },
        getCheckboxProps: record => ({
            disabled: record.name === 'Disabled User', // Column configuration not to be checked
            name: record.name,
        }),
        type: 'radio',
    };

    const salvarForncedorPcm = () => {
        if (fornecedorSelecionada) {

            const posFornecedorPcm = {
                fornecedorId: fornecedorSelecionada.id,
                numeroPcm: pcmResult.pedidoPcm
            } as PosFornecedorPcm;

            if (crf) {
                alterarForncedorDoPcmCrf(posFornecedorPcm).then(() => {
                    atualizarTabelaResult();
                });
            } else {
                alterarForncedorDoPcm(posFornecedorPcm).then(() => {
                    atualizarTabelaResult();
                });
            }

        } else {
            notification.error('Selecione um fornecedor');
        }
    }


    const colluns: ColumnProps<FornecedorResult>[] = [
        {
            title: 'N',
            dataIndex: 'index',
            width: '3%',
            sorter: (a, b) => compareTypeNumber(a.index, b.index),
        },
        {
            title: 'Número',
            dataIndex: 'numero',
            sorter: (a, b) => compareTypeNumber(a.numero, b.numero),
            width: '3%',
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                    <Row>
                        <FormInput
                            placeholder="Pesquisar"
                            name="numero"
                            style={{ marginTop: '15px' }}
                            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                            onPressEnter={() => {
                                if (typeof confirm === 'function') confirm();
                            }}
                        />
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Button
                                type="primary"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                                icon="commons-search"
                                size="small">
                                Pesquisar
                            </Button>
                        </Col>
                        <Col span={6}>
                            <FormResetButton
                                size="small"
                                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                beforeReset={() => {
                                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                }}>
                                Limpar
                            </FormResetButton>
                        </Col>
                    </Row>
                </Form>
            ),
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) =>
                record.numero !== undefined &&
                record.numero
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
        },
        {
            title: 'CNPJ',
            dataIndex: 'cnpj',
            sorter: (a, b) => compareText(a.cnpj, b.cnpj),
            width: '5%',
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                    <Row>
                        <FormInput
                            placeholder="Pesquisar"
                            name="cnpj"
                            style={{ marginTop: '15px' }}
                            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                            onPressEnter={() => {
                                if (typeof confirm === 'function') confirm();
                            }}
                        />
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Button
                                type="primary"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                                icon="commons-search"
                                size="small">
                                Pesquisar
                            </Button>
                        </Col>
                        <Col span={6}>
                            <FormResetButton
                                size="small"
                                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                beforeReset={() => {
                                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                }}>
                                Limpar
                            </FormResetButton>
                        </Col>
                    </Row>
                </Form>
            ),
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) =>
                record.cnpj !== undefined &&
                record.cnpj
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
        },
        {
            title: 'NOME',
            dataIndex: 'nome',
            sorter: (a, b) => compareText(a.nome, b.nome),
            width: '20%',
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                    <Row>
                        <FormInput
                            placeholder="Pesquisar"
                            name="nome"
                            style={{ marginTop: '15px' }}
                            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                            onPressEnter={() => {
                                if (typeof confirm === 'function') confirm();
                            }}
                        />
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Button
                                type="primary"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                                icon="commons-search"
                                size="small">
                                Pesquisar
                            </Button>
                        </Col>
                        <Col span={6}>
                            <FormResetButton
                                size="small"
                                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                beforeReset={() => {
                                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                }}>
                                Limpar
                            </FormResetButton>
                        </Col>
                    </Row>
                </Form>
            ),
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) =>
                record.nome !== undefined &&
                record.nome
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
        },
        {
            title: 'NOME RESUMIDO',
            dataIndex: 'nomeResumido',
            sorter: (a, b) => compareText(a.nomeResumido, b.nomeResumido),
            width: '20%',
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                    <Row>
                        <FormInput
                            placeholder="Pesquisar"
                            name="nomeResumido"
                            style={{ marginTop: '15px' }}
                            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                            onPressEnter={() => {
                                if (typeof confirm === 'function') confirm();
                            }}
                        />
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Button
                                type="primary"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                                icon="commons-search"
                                size="small">
                                Pesquisar
                            </Button>
                        </Col>
                        <Col span={6}>
                            <FormResetButton
                                size="small"
                                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                beforeReset={() => {
                                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                }}>
                                Limpar
                            </FormResetButton>
                        </Col>
                    </Row>
                </Form>
            ),
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) =>
                record.nomeResumido !== undefined &&
                record.nomeResumido
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
        },
        {
            title: 'NOME MATRIZ',
            dataIndex: 'nomeMatriz',
            sorter: (a, b) => compareText(a.nomeMatriz, b.nomeMatriz),
            width: '20%',
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                    <Row>
                        <FormInput
                            placeholder="Pesquisar"
                            name="nomeMatrizPesquisa"
                            style={{ marginTop: '15px' }}
                            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                            onPressEnter={() => {
                                if (typeof confirm === 'function') confirm();
                            }}
                        />
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Button
                                type="primary"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                                icon="commons-search"
                                size="small">
                                Pesquisar
                            </Button>
                        </Col>
                        <Col span={6}>
                            <FormResetButton
                                size="small"
                                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                beforeReset={() => {
                                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                }}>
                                Limpar
                            </FormResetButton>
                        </Col>
                    </Row>
                </Form>
            ),
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) =>
                record.nomeMatriz !== undefined &&
                record.nomeMatriz
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
        },

    ]

    return (
        <>
            <Tooltip title="ALTERAR FORNECEDOR">
                <Button
                    icon="arrows-swap"
                    onClick={() => {
                        setVisible(!visible);
                        setFornecedorSelecionada(undefined);
                    }}
                />
            </Tooltip>


            <Modal
                visible={visible}
                title="FORNECEDORES"
                onOk={() => { }}
                onCancel={() => { setVisible(!visible) }}
                footer={[
                    <Button key="back" onClick={() => {
                        setFornecedorSelecionada(undefined);
                        setVisible(!visible)
                    }}>
                        Retornar
                    </Button>,
                    <Button key="submit" type="primary" onClick={() => {
                        salvarForncedorPcm();
                    }}>
                        Salvar
                    </Button>,
                ]}
                width={1024}
            >

                <Table
                    dataSource={fornecedoresResult}
                    columns={colluns}
                    rowSelection={rowSelection}
                />

            </Modal>
        </>
    )
}

export default ModalFornecedor;